import { GetUser } from "../../utils/sessions";

export const buildParameter = {
         SaveDetail: (id, formdata) => {
           let param = {
             ID: parseInt(id),
             MODULE_GROUP: formdata.MODULE_GROUP,
             SEQUENCE: parseInt(formdata.SEQUENCE),
             MODULE_DESC: formdata.MODULE_DESC,
             SESSION_OWNER: GetUser(),
           };
           return param;
         },
       };
